import {createStyles} from '@material-ui/core/styles'
import {Colors} from 'components/common/useBaseStyle'

const ProductRegistrationOrganizationListStyle = () =>
  createStyles({
    detailTitle: {
      fontSize: 20,
      fontWeight: 700,
      color: 'black',
      marginBottom: 20,
    },
    cardWrapper: {
      display: 'flex',
      gap: 30,
    },
    chargeTypeButton: {
      padding: '6px 16px',
      backgroundColor: '#0cc7c780',
      fontSize: 14,
      borderRadius: 4,
      color: 'white',
      height: 36.5,
      fontWeight: 500,
    },
    chargeTypeButtonActive: {
      backgroundColor: '#0cc7c7',
    },
    informationWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      flex: 1,
    },
    cardTitle: {
      fontSize: 18,
      fontWeight: 700,
      color: 'black',
    },
    card: {
      background: 'white',
      borderRadius: '15px',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
      padding: '25px',
      position: 'relative',
      overflow: 'hidden',
      transform: 'translateY(0)',
      transition: 'all 0.3s ease',

      '&::before': {
        content: "''",
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '4px',
        background: 'linear-gradient(90deg, #0cc7c7, #00a8a8)',
      },
    },

    productSection: {
      padding: '10px 0',
      lineHeight: 1.6,
    },

    infoItem: {
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: '12px',
    },

    bullet: {
      color: '#0cc7c7',
      fontWeight: 'bold',
      marginRight: '8px',
      fontSize: '16px',
      lineHeight: 1.5,
    },

    infoText: {
      color: '#333',
      fontSize: '18px',
    },
    sectionInstitution: {
      width: '100%',
    },
    table: {
      position: 'relative',
      minWidth: 730,
      color: 'red',
      marginTop: '15px',
      '& td': {
        color: Colors.text.content,
        fontSize: '0.8125rem',
        lineHeight: 2,
        paddingTop: 6,
        paddingBottom: 6,
        height: 43,
      },
      marginBottom: 20,
    },
    tableHeader: {
      height: 42,
      backgroundColor: Colors.tableHeaderBackground,
      verticalAlign: 'middle',
      borderRadius: 10,
      '& th': {
        color: Colors.text.content,
        fontSize: '0.8125rem',
        lineHeight: '1rem',
        fontWeight: 'bold',
      },
    },
    headerMax: {
      border: '1px solid rgba(224, 224, 224, 1)',
      padding: 8,
    },

    productsGrid: {
      marginTop: '25px',
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(440px, 465px))',
      gap: '25px',
      alignItems: 'start',
    },
    infoProduct: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      padding: '15px',
      minWidth: '420px',
      maxWidth: '480px',
      background: 'white',
      border: '2px solid #e0e0e0',
      borderRadius: '12px',
      overflow: 'hidden',
      position: 'relative',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
      transition: 'all 0.3s ease',
      animation: 'fadeInUp 0.6s ease-out',
      cursor: 'pointer',
      '&:hover': {
        transform: 'translateY(-8px)',
        boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
        borderColor: '#0cc7c7',
      },
      '&::before': {
        content: "''",
        position: 'absolute',
        top: '-2px',
        left: '-2px',
        right: '-2px',
        bottom: '-2px',
        background: 'linear-gradient(45deg, #0cc7c7, #17a2b8, #0cc7c7)',
        borderRadius: '14px',
        zIndex: '-1',
        opacity: 0,
        transition: 'opacity 0.3s ease',
      },
      '&:hover::before': {
        opacity: 0.1,
      },
    },
    tabsUnderline: {
      display: 'flex',
      marginTop: '40px',
      borderBottom: '2px solid #e5e7eb',
      position: 'relative',
    },
    tabUnderline: {
      padding: '16px',
      background: 'none',
      border: 'none',
      fontSize: '15px',
      fontWeight: 600,
      color: '#6b7280',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      position: 'relative',
      '&:hover': {
        color: '#374151',
      },
    },
    underlineIndicator: {
      position: 'absolute',
      bottom: '-2px',
      height: '3px',
      background: 'linear-gradient(90deg, #3b82f6, #8b5cf6)',
      borderRadius: '2px 2px 0 0',
      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    },
    activeTabs: {
      color: '#0bc7c8 !important',
    },
    active: {
      height: '3px',
      borderRadius: '2px',
      backgroundColor: '#0bc7c8',
      marginBottom: '-2.5px',
    },
    productActive: {
      backgroundColor: '#a5eeee80',
    },
    productTitle: {
      fontSize: '20px',
      fontWeight: 'bold',
      color: '#333',
      marginBottom: '8px',
      flexGrow: 1,
    },

    productType: {
      color: '#666',
      fontSize: '14px',
      marginBottom: '12px',
    },

    rowCell: {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#F8F8F8',
      },
    },
    detailProduct: {
      marginTop: '25px',
    },
    toolBar: {
      display: 'flex',
      gap: '15px',
      marginTop: '10px',
    },
    productBtnV1: {
      display: 'flex',
      justifyContent: 'end',
      marginTop: '20px',
    },
  })

export default ProductRegistrationOrganizationListStyle
